$(document).ready(function () {

    if ($(".share").length > 0) {

        $(".share").click(function () {
            $(".content__toplinks-social").addClass("content__toplinks-active");
            $(".share").hide();
            return false;
        });

        $(".content__toplinks-close").click(function () {
            $(".content__toplinks-social").removeClass("content__toplinks-active");
            $(".share").show(); 
            return false;
        });

    }
});